import React, { Component } from 'react';
import BarcodeQRScannerComponent from './BarcodeScanner';

class AddInventoryWidget extends Component {

  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      times: 1
    };
  }

  close = () => {
    this.setState({ showModal: false });
  };

  open = () => {
    this.setState({ showModal: true });
  };

  handleOnSubmit = (e) => {
    e.preventDefault();
    this.props.onSubmit(this.state.times)
    this.setState({times: 1})
  }

  handleOnScan = (code, format, times) => {
    this.props.onScanItem(code, format, times)
    this.setState({showModal: false})
  }


  render(){
    let disabled = this.props.blocked ? {opacity: '0.6', pointerEvents: 'none'} : {};
    return(
      <div className="row">
        <div className="col-6">
          <div className={`form-group w-100 ${this.props.itemError ? "has-danger" : ""}`}>
            <div className="input-group" style={disabled}>
              <div className="input-group-addon">#</div>
              <form className='d-flex w-100' noValidate onSubmit={this.handleOnSubmit}>
                <input className='form-control' placeholder="Code" value={this.props.inputVal} onChange={this.props.onInputChange}/>
              </form>
            </div>
          </div>
        </div>
        {this.props.multiple_times_allowed && <div className="col-3">
          <div className={`d-flex w-100 justify-content-center form-group ${this.state.times < 1 && 'has-danger'}`}>
            <div className="input-group-addon w-40">Repeat </div>
            <input className="form-control" type="number" min='1' placeholder="Times" value={this.state.times} onChange={(e) => {this.setState({times: e.target.value})}} />
          </div>
        </div>}
        <div className={`col-${this.props.multiple_times_allowed ? '3' : '6'}`}>
            <span className="btn btn-primary scan-shipment-item" style={disabled} onClick={this.open}>
              <i className="fa fa-qrcode mr-05" aria-hidden="true"></i>
              <span>Scan</span>
            </span>
            <BarcodeQRScannerComponent
              show={this.state.showModal}
              onHide={this.close}
              onScan={(code, format, times) => this.handleOnScan(code, format, times)}
              multiple_times_allowed={this.props.multiple_times_allowed}
            />
        </div>
      </div>
    )
  }
}

export default AddInventoryWidget;
